import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { Gift, ArrowLeft } from "@phosphor-icons/react";
import { getStoredUserSession } from "@shared/hooks/useUserSession";

/** Progresul consumatorului în programele de fidelitate (REWARD-004). */

export const Route = createFileRoute("/app/rewards")({
  component: RewardsPage,
});

function RewardsPage() {
  const { userId, sessionToken } = getStoredUserSession();
  const rewards = useQuery(api.rewards.getMyRewards, userId && sessionToken ? { userId, sessionToken } : "skip");

  if (!userId || !sessionToken) {
    window.location.href = "/auth/login";
    return null;
  }

  return (
    <div className="min-h-screen bg-background pb-24 px-4 pt-4">
      <div className="flex items-center gap-3 mb-4">
        <Link to="/app/profile" search={{ success: false, canceled: false, session_id: undefined }} className="p-2 rounded-lg bg-white shadow-sm" aria-label="Înapoi">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-xl font-bold text-text">Recompensele mele</h1>
      </div>

      {rewards === undefined && (
        <div className="w-10 h-10 mx-auto mt-10 animate-spin motion-reduce:animate-none rounded-full border-4 border-primary border-t-transparent" />
      )}

      {rewards && rewards.programs.length === 0 && (
        <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
          <Gift size={40} className="mx-auto text-primary mb-3" />
          <p className="font-semibold text-text">Încă nicio vizită</p>
          <p className="text-sm text-text-muted mt-1">
            Plătește cu RoPay prin suuper la comercianții parteneri și vizitele se adună aici.
          </p>
        </div>
      )}

      <div className="space-y-3">
        {rewards?.programs.map((p) => (
          <div key={p.partnerId} className="bg-white rounded-2xl p-5 shadow-sm" data-testid="reward-program">
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-semibold text-text">{p.merchantName}</p>
                <p className="text-sm text-text-muted">{p.rewardLabel}</p>
              </div>
              {p.available > 0 && (
                <span className="px-2.5 py-1 rounded-full bg-primary text-white text-xs font-semibold whitespace-nowrap">
                  Recompensă disponibilă
                </span>
              )}
            </div>
            <div className="mt-3 h-2 bg-gray-100 rounded-full overflow-clip" aria-hidden="true">
              <div className="h-full bg-primary rounded-full" style={{ width: `${(p.progress / p.target) * 100}%` }} />
            </div>
            <p className="mt-2 text-sm text-text-muted">
              {p.progress}/{p.target} vizite · încă {p.toNext} până la {p.rewardLabel}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
